









import { getTaskTypesOfProject, TaskType } from "@/api/task-type-api";
import SelectOption from "@/common/ui/presenters/select-option";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

/**
 * 工程の業種の選択
 */
@Component({})
export default class TaskTypeSelect extends Vue {
  @Prop({ required: true }) project!: number; // 現場ID
  @Prop({ default: "" }) value!: string;
  @Prop({ type: Boolean }) autofocus?: boolean;

  taskType: string = "";
  taskTypes: TaskType[] = [];

  get options(): SelectOption[] {
    return this.taskTypes.map(t => ({
      text: t.name,
      value: String(t.taskTypeId)
    }));
  }

  @Watch("value", { immediate: true })
  onDefaultValueChanged(value: string) {
    this.taskType = value;
  }

  @Watch("project", { immediate: true })
  onProjectChanged(projectId: number) {
    this.initOptions(projectId);
  }

  private async initOptions(projectId: number): Promise<void> {
    this.taskTypes = await getTaskTypesOfProject(projectId);
  }
}
